module.exports = __webpack_public_path__ + "static/media/consultationIcon.f66c9bff.svg";